import axios from 'axios';
import { BackEndVersion } from 'types';
import mainService from './mainService';
const CancelToken = axios.CancelToken;

let requestDataCancel;

export function metOceanRecords(portId: number, backEnd: BackEndVersion, data: any) {
    return mainService
        .post(`metOcean/records`, { ...data, portId, backEnd })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function metOceanAtTime(portId: number, backEnd: BackEndVersion, data: any) {
    if (requestDataCancel !== undefined) {
        requestDataCancel();
    }
    return mainService
        .post(
            `metOcean/atTime`,
            { ...data, portId, backEnd },
            {
                cancelToken: new CancelToken(function executor(c) {
                    requestDataCancel = c;
                }),
            }
        )
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}
